import React from 'react';
import { ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, } from '@voltmoney/schema';
import Typography from '../typography/Typography';
import { Image as Img, Platform, View } from "react-native";
import { Icon } from "../icon/Icon";
const PanView = ({ name, panNumber }) => {
    const panDetailsView = () => {
        return (React.createElement(View, null,
            React.createElement(Typography, { label: name, fontWeight: "700", fontSize: FontSizeTokens.XL, lineHeight: 24, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Poppins }),
            React.createElement(Typography, { label: panNumber, fontWeight: "400", fontSize: FontSizeTokens.XL, lineHeight: 24, color: ColorTokens.Grey_Charcoal, fontFamily: FontFamilyTokens.Inter })));
    };
    return (React.createElement(View, { style: { height: 194, borderRadius: 10, borderWidth: 1, borderColor: "#ACD8F6", padding: 20, width: '100%', backgroundColor: "#D7EFFF", flexDirection: 'column', justifyContent: 'space-between' } },
        React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between' } },
            React.createElement(Icon, { name: IconTokens.IncomeTax, size: IconSizeTokens.Size56 }),
            React.createElement(Icon, { name: IconTokens.AshokChakra, size: IconSizeTokens.Size56 }),
            React.createElement(Img, { source: { uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/bharat_india.png" }, style: { width: 79, height: 31 } })),
        React.createElement(View, { style: {
                flexDirection: 'row',
                justifyContent: 'space-between',
                position: 'absolute',
                bottom: 20,
                width: Platform.OS !== "web" ? '100%' : "92%",
                ...Platform.OS !== "web" && {
                    right: 0,
                    marginRight: 16
                }
            } },
            panDetailsView(),
            React.createElement(Img, { source: { uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/pan_placeHolder.png" }, style: { width: 48, height: 48 } }))));
};
export default (PanView);
